<template>
  <div class="container">
      <div class="business-banner">
          <div class="business-write">
            <p class="p1">业务介绍</p>
            <p class="p2 font-medium">BUSINESS INTRODUCTION</p>
          </div>
      </div>
      <div class="business-mollybox">
        <div class="business-mollybox-title">
          <p class="p1">MollyBox魔力猫盒-订阅制商城</p>
          <p class="p2 font-medium">SUBSCRIPTION SYSTEM</p>
        </div>
        <div class="business-mollybox-content">
          <div class="business-mollybox-main">
            <div class="buiness-mollybox-maincenter">
              <div class="business-mollybox-main-leftimage">
                <img :src="leftimage" alt=""/>
              </div>
              <div class="business-mollybox-main-righttext">
                <p class="p1">整合每月养猫所需用品，省去断粮、挑选玩具罐头等琐事，让铲屎官真正实现轻松养猫、简单养猫。</p>
                <p class="p2">就像牛奶定期配送上门一样，养宠为什么不能更省心？MollyBox魔力猫盒推出订阅商城，将每月养宠生活所需打包配送，免去反复选购的烦恼。我们希望用订阅服务解放用户时间，让主人与猫咪拥有更多相处的美好时光。</p>
                <p class="p3">魔力猫盒已与上百个品牌商合作，提供千余款进口商品，所有品牌产品及配方均经过严格把关与筛选。每月推出的魔力猫盒，除用户自行挑选的猫粮外，其余商品均由专业兽医、资深养宠人士及专业产品测试团队共同筛选，根据季节变化与养宠需求灵活搭配，例如夏季配备化毛膏、梳子、散热冰垫，冬季配备保暖用品，同时结合当下受欢迎的宠物新品，全面满足用户养猫的日常所需。</p>
                <p class="p4">让养猫更轻松、更简单，为铲屎官与猫咪创造舒适、安心的养宠生活——这是我们持续努力的方向。</p>
              </div>
            </div>
            <div class="buiness-mollybox-mainfooter">
              <div class="buiness-mollybox-mainfooter-image">
                <img src="../assets/business/code_mao.png" />
                <p>微信扫码查看MollyBox魔力猫盒官方商城</p>
              </div>
              <div class="aside"></div>
              <div class="buiness-mollybox-mainfooter-listimages">
                <ul>
                  <li>
                    <a target="_blank" href="https://weibo.com/mollybox">
                      <img class="img1" src="../assets/business/ic_weibo.png" />
                      <p class="p1">MollyBox魔力猫盒</p>
                    </a>
                  </li>
                  <li @click="copy">
                      <img src="../assets/business/ic_xiaohongshu.png" />
                      <p class="p2">MollyBox魔力猫盒旗舰店 </p>
                  </li>
                  <li>
                    <a target="_blank" href="https://mollybox.jiyoujia.com/">
                      <img src="../assets/business/ic_taobao.png" />
                      <p class="p2">MollyBox魔力猫盒</p>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="business-membership">
        <div class="business-membership-title">
          <p class="p1">六脚兽-会员制商城</p>
          <p class="p2 font-medium">MEMBERSHIP SYSTEM</p>
        </div>
        <div class="business-container">
            <div class="business-main">
                <div class="business-membership-image">
                  <img :src ="membershipimage" alt=""/>
                </div>
                <div class="business-membership-text">
                  <p class="p1">
                    我们为会员提供专属服务与优惠价格，致力于打造高性价比的购物体验。通过优选商品、清晰分类和简洁的购物流程，降低用户决策成本，让会员享受便捷、省心的购物过程。
                  </p>
                  <p class="p2">
                    六脚兽依托多年宠物行业服务经验及与各大品牌供应链的良好合作关系，由兽医和资深养宠专业人士联合甄选全球正品好物，为会员用户提供全面优质的产品。在坚持科学养宠理念的前提下，我们持续优化成本与选品，力求为会员带来实在的性价比。
                  <p class="p3">
                    六脚兽致力于将交易利润回归会员，让每一次消费都成为一次安心、愉悦的体验。我们将持续倾听用户反馈，不断优化产品与服务，以真诚和品质赢得会员的长期信任。
                  </p>
                </div>
                <div class="business-membership-footimg">
                    <img src="../assets/business/code_gou.png" />
                    <p class="p1">微信扫码查看六脚兽VIP商城</p>
                </div>
            </div>
        </div>
      </div>
      <div class="business-system">
        <div class="business-system-title">
          <p class="p1">自媒体平台</p>
          <p class="p2 font-medium">SELF-MEDIA PLATFORM</p>
        </div>
        <div class="business-system-zmt">
          <ul>
            <li v-for="(item,index) in items" :key="index">
              <img :src="item.image" alt=""/>
              <div class="business-system-zmt-right">
                <p class="p1" v-html="item.title"></p>
                <p class="p2" v-html="item.textfirst"></p>
                <p class="p3">{{item.texttwo}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Business',
  data(){
    return{
      leftimage:require('../assets/business/pic_1.jpg'),
      membershipimage:require('../assets/business/pic_2.jpg'),
      items:[
        {
          image:require('../assets/business/pic_3.jpg'),
          title:'躲猫猫在秘密山谷',
          textfirst:'“躲猫猫在秘密山谷”秉持三个核心原则：有用、有趣、有情感。我们希望在实用性、功能性与情感共鸣之间找到平衡，为用户提供多元且有温度的内容。通过塑造IP形象“谷主”，并将用户代入“谷民”角色，我们努力与用户建立更深层次的情感连接，营造活跃、有归属感的互动氛围。',
          texttwo:'',
        },
         {
          image:require('../assets/business/pic_4.jpg'),
          title:'MollyBox魔力猫盒',
          textfirst:'“MollyBox魔力猫盒”专注于优质内容的产出与传播，通过图片、文字、视频等形式，将专业、贴心的养宠体验传递给消费者。同时，我们与有赞商城的商业化运营深度协同，为用户打造从内容到购买的一站式完整购物体验。',
          texttwo:'',
        },
         {
          image:require('../assets/business/pic_5.jpg'),
          title:'一犬一话',
          textfirst:'“一犬一话”作为萌宠原创视频领域的先行者，通过优质图文形式打造多个专栏，专注于狗狗的饮食、玩乐、健康及行为习惯，并分享行业内外的人物与故事。作为一本有温度、有态度的狗狗生活指南，我们为主人与狗狗提供有价值、有趣又好玩的资讯，陪伴每一位养狗人探索人与宠物共同生活的更多可能。',
          texttwo:'',
        },
      ]
    }
  },
  methods:{
     copy() {
       alert("打开小红书APP搜索 “MollyBox魔力猫盒旗舰店”")

      // const input = document.createElement('input')
      // document.body.appendChild(input)
      // input.setAttribute('value',"MollyBox")
      // input.select()
      // if (document.execCommand('copy')) {
      //   document.execCommand('copy')
      //   alert("已为您复制名称，请开启小程序进行店铺的搜索与进入")
      // }
      // document.body.removeChild(input)
     }
  }
}
</script>

<style scoped lang="less">
  .business-banner{
      width: 100%;
      height: 400px;
      background: url('../assets/business/banner.jpg') center center no-repeat;
      background-size:cover ;
      // min-height: 100vh;
      text-align: center;
      .business-write{
        padding-top: 98px;
        .p1{
          font-size: 40px;
          padding: 116px 0 27px;
          letter-spacing: 6px;
          color: #ffffff;
          font-weight: 600;
        }  
        .p2{
          
          font-size: 20px;
          letter-spacing: 5px;
          color: #ffffff;
        }  
      }
  }
  .business-mollybox{
    .business-mollybox-title{
      text-align: center;
      .p1{
        .businessp1;
      }
      .p2{
        .businessp2;
      }
    }
    .business-mollybox-content{
      width: 100%;
      .business-mollybox-main{
        width: 1100px;
        height: 851px;
        background-color: #ffffff;
        border: solid 1px #e5e5e5;
        margin:  0 auto;
        .buiness-mollybox-maincenter{
          width: 100%;
          height: 568px;
          .business-mollybox-main-leftimage{
            float: left;
            width: 551px;
            height: 568px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
          }
          .business-mollybox-main-righttext{
            float: left;
            width: 451px;
            text-align: justify;
            padding: 33px 43px 0 53px;
            p{
              
              font-size: 16px;
              line-height: 29px;
              letter-spacing: 0px;
              color: #666666;
              text-indent: 32px;
            }
            .p1{
              padding-bottom: 7px;
            }
            .p3{
              padding:7px 0; 
            }
          }
        }
        .buiness-mollybox-mainfooter{
          .buiness-mollybox-mainfooter-image{
            float: left;
            width: 464px;
            height: 283px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            img{
              width: 160px;
              height: 160px;
            }
            p{
            
              font-size: 16px;
              letter-spacing: 0px;
              color: #666666;
              padding-top: 24px;
            }
          }
          .aside{
            float: left;height: 190px;border-right: 1px solid #e6e6e6;margin-top: 48px;
          }
           .buiness-mollybox-mainfooter-listimages{
            float: left;
            width: 1100-465px;
            height: 283px;
            ul{
              padding: 0 58px;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: space-around;
              li{
                display: flex;
                align-items: center;
                justify-content:space-evenly;
                flex-direction: column;
                text-align: center;
                cursor: pointer;
                .img1{
                  // width: 60px;
                  // height: 48px;
                  // padding-bottom:4px; 
                  // display: block;
                }
                a{
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                }
                img{
                  // width: 44px;
                  display: block;
                  height: 44px;
                }
                p{
                  
                  font-size: 14px;
                  letter-spacing: 0px;
                  color: #333333;
                  padding-top:23px; 
                }
              }
            }
          }
        }
      }
      
    }
  }
  .business-membership{
    .business-membership-title{
      text-align: center;
      .p1{
        .businessp1;
      }
      .p2{
        .businessp2;
      }
    }
    .business-container{
      width: 100%;
      background: #f9f9f9;
      border-top:1px solid #f9f9f9; //空白边叠加，不然里面的margin负数不行
      margin-top:93px; 
      .business-main{
          width: 1100px;
          margin: -93px auto 0;
          .business-membership-image{
            padding-bottom:59px; 
            margin-top:-93px; 
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 364px;
              img{
               display: block
              }
            }
            .business-membership-text{
              text-align: justify;
              p{
                line-height: 29px;
                font-size: 16px;
                letter-spacing: 0px;
                text-indent: 32px;
                color: #333333;
                padding-bottom: 30px;
              }
              .p3{
                padding-bottom: 50px;
              }
            }
            .business-membership-footimg{
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                padding-top: 10px;
                img{
                  width: 150px;
                  height: 150px;
                }
                p{
                  font-size: 16px;
                  letter-spacing: 0px;
                  color: #666666;
                  padding:33px 0 83px; 
                }
            }
        }
    }
    
    
  }
  .business-system{
    .business-system-title{
      text-align: center;
      .p1{
        .businessp1;
      }
      .p2{
        .businessp2;
      }
    }
    .business-system-zmt{
       width: 1100px;
       margin: 0 auto;
       ul{
         width: 100%;
         li{
           border: 1px solid #eaeaea;
           height: 570px;
           margin-bottom: 119px;
           display: flex;
             img{
               display: block;
               height: 100%;
             }
           .business-system-zmt-right{
             padding: 0 60px 0 40px;
             text-align: justify;
             .p1{
                font-size: 22px;
                letter-spacing: 0px;
                color: #333333;
                padding-top:112px; 
                font-weight: 600;
             }
             .p2,.p3{
               line-height: 29px;
               font-size: 16px;
               letter-spacing: 0px;
               color: #333333; 
             }
             .p2{
               padding:38px 0 28px;
             }
             
           }
         }
       }
    }
  }
//公用
.businessp1{
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 5px;
    color: #333333;
    padding: 120px 0 21px 0;
    font-weight: 600;
}
.businessp2{
    
    font-size: 16px;
    letter-spacing: 4px;
    color: #666666;
    padding-bottom:80px; 
}

</style>
